<script lang="ts">
import { getContext } from "svelte";

import type { Writable } from "svelte/store";

import { Accordion, AccordionItem, TabContent, TabPane } from "sveltestrap";
import type { Diligence } from "../../../Model/Diligence";
import type { PoliceManifestation } from "../../../Model/PoliceManifestation";
import type { PoliceManifestationTraffic } from "../../../Model/PoliceManifestationTraffic";
import type { Third } from "../../../Model/Third";
import { affectedService, complainantService, complainantTrafficService, denouncedService, denouncedTrafficService, pedestrianService, witnessService } from "../../../services";
import AddThirdModal from "../../AddThirdModal.svelte";
import AllListDataComplainants from "../../AllListDataComplainants.svelte";
import FilesList from "../../FilesList.svelte";
import DiligenceAffectedData from "../Global/DiligenceAffectedData.svelte";
import DiligencePedestrianData from "../Global/DiligencePedestrianData.svelte";
import DiligenceWitnessData from "../Global/DiligenceWitnessData.svelte";
    import PoliceManifestationInitialForm from "../Global/PoliceManifestationInitialForm.svelte";
import DiligenceComplainantTrafficData from "./Data/DiligenceComplainantTrafficData.svelte";
import DiligencePassengerTrafficData from "./Data/DiligencePassengerTrafficData.svelte";
import PoliceManifestationTrafficData from "./Data/PoliceManifestationTrafficData.svelte";

type ThirdType = 'complainant' | 'passenger' | 'witness' | 'pedestrian' | 'affected';

export let diligence: Diligence;

 
let complainantsThirds: Third[] = [];
let complainantThird: Third;
let complainantThirdId: string = '';

let passengersThirds: Third[] = [];
let passengerThird: Third;
let passengerThirdId: string = '';

let witnesssThirds: Third[] = [];
let witnessThird: Third;
let witnessThirdId: string = '';

let pedestriansThirds: Third[] = [];
let pedestrianThird: Third;
let pedestrianThirdId: string = '';

let affectedsThirds: Third[] = [];
let affectedThird: Third;
let affectedThirdId: string = '';

let openModal = false;
let openComplainantModal = false;
let openPassengerModal = false;
let openWitnessModal = false;
let openPedestrianModal = false;
let openAffectedModal = false;

let onChangeThird: (event: CustomEvent<Third>) => Promise<void> = async () => {};

$: loadForm(diligence);

async function loadForm(diligence){
  await Promise.all([ 
      loadComplainants(diligence),
      loadPassengers(diligence),
      loadWitness(diligence),
      loadPedestrian(diligence),
      loadAffected(diligence)
    ]) 
}

async function loadComplainants(diligence){
  let opts = {
      offset : 0,
      limit : 25,
      filters: {
          diligenceId: diligence.id,
      }
  }
  complainantsThirds = await complainantTrafficService.findThirds(opts);
  complainantsThirds.sort((a,b) => {
      return a.name < b.name ? -1 : 1;
  })
}

async function loadPassengers(diligence){
  let opts = {
      offset : 0,
      limit : 100,
      filters: {
          diligenceId: diligence.id,
      }
  }
  passengersThirds = await denouncedTrafficService.findThirds(opts);
  passengersThirds.sort((a,b) => {
      return a.name < b.name ? -1 : 1;
  })
}

async function loadWitness(diligence){
  
  let opts = {
      offset : 0,
      limit : 100,
      filters: {
          diligenceId: diligence.id,
      }
  }

  witnesssThirds = await witnessService.findThirds(opts);
  witnesssThirds.sort((a,b) => {
      return a.name < b.name ? -1 : 1;
  })
}

async function loadPedestrian(diligence){
  
  let opts = {
      offset : 0,
      limit : 100,
      filters: {
          diligenceId: diligence.id,
      }
  }

  pedestriansThirds = await pedestrianService.findThirds(opts);
  pedestriansThirds.sort((a,b) => {
      return a.name < b.name ? -1 : 1;
  })
}


async function loadAffected(diligence){
  
  let opts = {
      offset : 0,
      limit : 100,
      filters: {
          diligenceId: diligence.id,
      }
  }

  affectedsThirds = await affectedService.findThirds(opts);
  affectedsThirds.sort((a,b) => {
      return a.name < b.name ? -1 : 1;
  })
}




async function saveNewComplainantTraffic({ detail: third }: CustomEvent<Third>){
      await complainantService.createComplainant(third.id, diligence.id);
      await complainantTrafficService.createComplainantTraffic(third.id, diligence.id);
      complainantsThirds.push(third);
      complainantsThirds = complainantsThirds;
}

async function saveNewPasengerTraffic({ detail: third }: CustomEvent<Third>){
      await denouncedService.createDenounced(third.id, diligence.id);
      await denouncedTrafficService.createDenouncedTraffic(third.id, diligence.id);
      passengersThirds.push(third);
      passengersThirds = passengersThirds;
}

async function saveNewWitnessTraffic({ detail: third }: CustomEvent<Third>){
      await witnessService.createWitness(third.id, diligence.id);
      witnesssThirds.push(third);
      witnesssThirds = witnesssThirds;
}

async function saveNewPedestrianTraffic({ detail: third }: CustomEvent<Third>){
      await pedestrianService.createPedestrian(third.id, diligence.id);
      pedestriansThirds.push(third);
      pedestriansThirds = pedestriansThirds;
}

async function saveNewAffectedTraffic({ detail: third }: CustomEvent<Third>){
      await affectedService.createAffected(third.id, diligence.id);
      affectedsThirds.push(third);
      affectedsThirds = affectedsThirds;
}

async function openComplaintModal({detail}: CustomEvent<Third>){
  complainantThird = complainantsThirds.find(c => c.id == detail.id)
  if (complainantThird) {
    complainantThirdId = detail.id
    openComplainantModal = true
  }
}

async function openDenouncedModal({detail}: CustomEvent<Third>){
  passengerThird = passengersThirds.find(c => c.id == detail.id)
  if (passengerThird) {
    passengerThirdId = detail.id
    openPassengerModal = true
  }
}

async function openActionWitnessModal({detail}: CustomEvent<Third>){
  witnessThird = witnesssThirds.find(c => c.id == detail.id)
  if (witnessThird) {
    witnessThirdId = detail.id
    openWitnessModal = true
  }
}


async function openActionPedestrianModal({detail}: CustomEvent<Third>){
  pedestrianThird = pedestriansThirds.find(c => c.id == detail.id)
  if (pedestrianThird) {
    pedestrianThirdId = detail.id
    openPedestrianModal = true
  }
}

async function openActionAffectedModal({detail}: CustomEvent<Third>){
  affectedThird = affectedsThirds.find(c => c.id == detail.id)
  if (affectedThird) {
    affectedThirdId = detail.id
    openAffectedModal = true
  }
}

async function onAddNewThird(type: ThirdType){
  switch (type) {
    case 'complainant':
      onChangeThird = saveNewComplainantTraffic;
    break;
    case 'passenger':
      onChangeThird = saveNewPasengerTraffic;
    break;
    case 'witness':
      onChangeThird = saveNewWitnessTraffic;
    break;
    case 'pedestrian':
      onChangeThird = saveNewPedestrianTraffic;
    break;
    case 'affected':
      onChangeThird = saveNewAffectedTraffic;
    break;
    default:
      throw new Error(`Error al obtener el type a guardar`);
  }

  openModal = true
}

function toggle() {
  openModal = !openModal;
}
function toggleComplainantModal(){
  openComplainantModal = !openComplainantModal
}
function toggleDenouncedModal(){
  openPassengerModal = !openPassengerModal
}
function toggleWitnessModal(){
  openWitnessModal = !openWitnessModal
}
function togglePedestrianModal(){
  openPedestrianModal = !openPedestrianModal
}

function toggleAffectedModal(){
  openAffectedModal = !openAffectedModal
}

function saveComplainant(){
  loadForm(diligence);
}

async function deleteComplaiant(event) {
  await complainantTrafficService.deleteComplainantTraffic(event.detail);

  await complainantService.deleteComplainantGlobal(event.detail);

  loadComplainants(diligence)
}

async function deleteDenounced(event) {
  await denouncedTrafficService.deleteDenouncedTraffic(event.detail);

  await denouncedService.deleteDenouncedGlobal(event.detail);

  loadPassengers(diligence)
}

async function deleteWitness(event) {
  await witnessService.deleteWitness(event.detail);

  loadWitness(diligence)
}

async function deletePedestrian(event) {
  await pedestrianService.deletePedestrian(event.detail);

  loadPedestrian(diligence)
}

async function deleteAffected(event) {
  await affectedService.deleteAffected(event.detail);

  loadAffected(diligence)
}

</script>

<style lang="scss">

  :global(.accordion){
    padding-right: 3px !important;
    padding-left: 3px !important;
  }

  :global(.accordion-item){
    border: 1px solid #dee2e6 !important;
    border-radius: 0.25rem !important;
  }

</style>


<Accordion>
  <AccordionItem header="Manifestación Policial Inicial">
    <PoliceManifestationInitialForm {diligence} />
  </AccordionItem>
  <AccordionItem header="Conductores">
      <AllListDataComplainants thirds={complainantsThirds} on:editThird={openComplaintModal} on:newThird={() => onAddNewThird('complainant')} on:deleteComplainant={deleteComplaiant}/>
  </AccordionItem>
  <AccordionItem header="Ocupantes">
      <AllListDataComplainants thirds={passengersThirds} on:editThird={openDenouncedModal} on:newThird={() => onAddNewThird('passenger')} on:deleteComplainant={deleteDenounced}/>
  </AccordionItem>
 <AccordionItem header="Testigos">
      <AllListDataComplainants thirds={witnesssThirds} on:editThird={openActionWitnessModal} on:newThird={() => onAddNewThird('witness')} on:deleteComplainant={deleteWitness}/>
  </AccordionItem>
  <AccordionItem header="Peatones"> 
      <AllListDataComplainants thirds={pedestriansThirds} on:editThird={openActionPedestrianModal} on:newThird={() => onAddNewThird('pedestrian')} on:deleteComplainant={deletePedestrian}/>
  </AccordionItem>
  <AccordionItem header="Afectados Colaterales">
    <AllListDataComplainants thirds={affectedsThirds} on:editThird={openActionAffectedModal} on:newThird={() => onAddNewThird('affected')} on:deleteComplainant={deleteAffected}/>  
  </AccordionItem>
  <AccordionItem header="Manifestación Policial">
    <PoliceManifestationTrafficData diligence={diligence} />
  </AccordionItem>
  <AccordionItem header="Archivos">
    <FilesList contextId={diligence.id}/>
  </AccordionItem>
</Accordion>


<AddThirdModal
  open={openModal}
  {toggle}
  thirdId={complainantThirdId}
  on:changeThird={onChangeThird}
/>

<DiligenceComplainantTrafficData 
  open={openComplainantModal}
  toggle={toggleComplainantModal}
  complainantThird={complainantThird} 
  diligenceId={diligence.id} 
  on:saveComplainant={(event) => saveComplainant()}
/>

<DiligencePassengerTrafficData
  open={openPassengerModal}
  toggle={toggleDenouncedModal}
  denouncedThird={passengerThird} 
  diligenceId={diligence.id} 
  on:saveComplainant={(event) => saveComplainant()}
/>

<DiligenceWitnessData
  open={openWitnessModal}
  toggle={toggleWitnessModal}
  witnessThird={witnessThird} 
  diligenceId={diligence.id} 
  on:saveWitness={(event) => saveComplainant()}
/>


<DiligencePedestrianData
  open={openPedestrianModal}
  toggle={togglePedestrianModal}
  pedestrianThird={pedestrianThird} 
  diligenceId={diligence.id} 
  on:saveWitness={(event) => saveComplainant()}
/>

<DiligenceAffectedData
  open={openAffectedModal}
  toggle={toggleAffectedModal}
  affectedThird={affectedThird} 
  diligenceId={diligence.id} 
  on:saveAffected={(event) => saveComplainant()}
/>
